module.exports = __webpack_public_path__ + "static/media/inplayer-logo-dark-blue.3a7b8254.svg";